/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Name_LabelInputs */

const en_us2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const pt_br2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const es_419_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_pt2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const fr_fr2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_de2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_it2_gyms_name_label = /** @type {(inputs: Gyms_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Gyms_Name_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_name_label = /** @type {((inputs?: Gyms_Name_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Name_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_name_label(inputs)
	if (locale === "es-419") return es_419_gyms_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_name_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_name_label(inputs)
	if (locale === "de-DE") return de_de2_gyms_name_label(inputs)
	if (locale === "it-IT") return it_it2_gyms_name_label(inputs)
	return en_us2_gyms_name_label(inputs)
});
export { gyms_name_label as "gyms.name_label" }